import { logError } from 'errors/errorHandler';

export const DefaultServiceAction = (service: Function, action: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({ type: `@@service/${action}_REQUEST` });
      let { data } = await service();
      dispatch({ type: `@@service/${action}_SUCCESS`, payload: data });
    } catch (error) {
      dispatch({ type: `@@service/${action}_ERROR`, error });
      logError(error);
    }
  };
};
